import { EViewedCianIdsActionType } from './types';
import { actionGenerator } from '../../../common/utils/redux/actionGenerator';

export const resetViewedCianIds = actionGenerator<EViewedCianIdsActionType.Reset>(EViewedCianIdsActionType.Reset);
